// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import vSelect from 'vue-select'
import App from './App'
import router from './router/routerPublic'
import store from './store.js'
import VueResource from 'vue-resource'
import i18n from './i18n'

import 'vue-select/dist/vue-select.css'


/* eslint-disable no-unused-vars */
const API_PREFIX = '/public/api/'

if (!window.appState.hkom) {
  require('./assets/sass/main.scss')
} else {
  require('./assets/sass/main-hkom.scss')
}

Vue.config.productionTip = false

Vue.prototype.$store = store

Vue.prototype.$store.init(window.appState)
Vue.use(VueResource)
Vue.component('v-select', vSelect)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/mainPublic.js